import React, { forwardRef } from "react";
import { useBookingEditText } from "../text";
import { GoTriangleDown } from "react-icons/go";
import Select, { components } from "react-select";
import SelectionButton from "./SelectionButton";
import { createTypographyHelper } from "../../../../utils/typography";
import CountryFlag from "../../../common/CountryFlag";

const PassengerInformationSection = forwardRef(({
  bookingFor,
  setBookingFor,
  passengerTitle,
  setPassengerTitle,
  formatPassengerTitle,
  passengerTitleOptions,
  passengerName,
  setPassengerName,
  countryCode,
  setCountryCode,
  setPrefixPhoneNumber,
  formatPhoneCountry,
  phoneCountryOptions,
  phoneNumber,
  setPhoneNumber,
  isNameInvalid = false,
  isPhoneInvalid = false,
}, ref) => {
  const { t, language } = useBookingEditText();
  const getTypographyClass = createTypographyHelper(language);

  return (
    <section ref={ref} className="tw:!mb-4 tw:!bg-white">
      <div className="tw:!px-5 tw:!pt-5 tw:!pb-2">
        <div className="tw:!mb-0 tw:!text-[#282828] tw:!text-[16px] tw:!font-[600] tw:font-hanken-grotesk">
          {t("editBooking.BookingEditPage.passengerInformation.title")}
        </div>
      </div>
      <div className="tw:flex tw:flex-col tw:gap-4 tw:px-5 tw:py-5 tw:lg:px-6 tw:lg:py-6">
        {/* <div className="tw:flex tw:flex-col">
          <div className={`tw:mb-2 tw:text-[#212529] ${getTypographyClass(14)}`}>
            Who are you booking this transfer for?
            <span className="tw:text-[#ea4335]">*</span>
          </div>
          <div className="tw:flex tw:flex-wrap tw:gap-1.5">
            <SelectionButton
              options={[
                { value: "myself", label: "For myself" },
                { value: "someone_else", label: "For someone else" },
              ]}
              value={bookingFor}
              onChange={setBookingFor}
              className={getTypographyClass(14)}
              fullWidth
            />
          </div>
        </div> */}

        <div className="tw:flex tw:flex-col tw:gap-6 tw:rounded-[5px] tw:border tw:border-[#e8e8e8] tw:bg-white tw:p-5">
          {/* {bookingFor === "someone_else" && (
            <>
              <div className="tw:flex tw:flex-col tw:gap-2.5">
                <div className={`tw:text-[#212529] ${getTypographyClass(14)}`}>
                  Select Passenger
                </div>
                <Select
                  placeholder="Select a Passenger"
                  classNamePrefix="react-select-existing-passenger"
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      height: "50px",
                      borderRadius: "5px",
                      border: "1px solid #e8e8e8",
                      backgroundColor: "#ffffff",
                      fontSize: "15px",
                      boxShadow: "none",
                      "&:hover": {
                        border: "1px solid #e8e8e8",
                      },
                      fontWeight: "normal",
                    }),
                    valueContainer: (baseStyles) => ({
                      ...baseStyles,
                      paddingLeft: "14px",
                      fontWeight: "normal",
                    }),
                    menu: (baseStyles) => ({
                      ...baseStyles,
                      borderRadius: "5px",
                      marginTop: "4px",
                    }),
                    option: (baseStyles, state) => ({
                      ...baseStyles,
                      fontSize: "15px",
                      backgroundColor: state.isSelected ? "#dbbe78" : state.isFocused ? "#eddfbb" : "#ffffff",
                      color: state.isSelected ? "#ffffff" : "#282828",
                      cursor: "pointer",
                    }),
                    singleValue: (baseStyles) => ({
                      ...baseStyles,
                      fontWeight: "normal",
                    }),
                  }}
                  autoComplete="off"
                  onChange={(option) => setSelectedPassenger(option)}
                  value={selectedPassenger}
                  options={savedPassengerOptions}
                  components={{
                    DropdownIndicator: (props) => (
                      <components.DropdownIndicator {...props}>
                        <div className="tw:pr-2">
                          <GoTriangleDown color="#DBBE78" size={16} />
                        </div>
                      </components.DropdownIndicator>
                    ),
                    IndicatorSeparator: () => null,
                  }}
                />
              </div>

              <div className="tw:flex tw:items-center tw:gap-6">
                <div className="tw:h-px tw:flex-1 tw:bg-[#e8e8e8]" />
                <div className={`tw:text-[#8d8d8d] ${getTypographyClass(14)}`}>New Passenger</div>
                <div className="tw:h-px tw:flex-1 tw:bg-[#e8e8e8]" />
              </div>
            </>
          )} */}

          <div className="tw:flex tw:flex-col tw:gap-2.5">
            <div className="tw:flex tw:flex-col tw:gap-1">
              <div className={`tw:text-[#212529] ${getTypographyClass(14)}`}>
                {t("editBooking.BookingEditPage.passengerInformation.passengerName")}<span className="tw:text-[#ea4335]">*</span>
              </div>
              <div className={`tw:m-0 tw:text-[rgba(78,78,78,0.87)] ${getTypographyClass(12)}`}>
                {t("editBooking.BookingEditPage.passengerInformation.passengerNameInfo")}
              </div>
            </div>
            <div className="tw:flex tw:gap-2">
              <div className="tw:w-[150px]">
                <Select
                  placeholder="Title"
                  classNamePrefix="react-select-passenger-title"
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      height: "50px",
                      borderRadius: "5px",
                      border: "1px solid #e8e8e8",
                      backgroundColor: "#ffffff",
                      fontSize: "15px",
                      boxShadow: "none",
                      "&:hover": {
                        border: "1px solid #e8e8e8",
                      },
                      fontWeight: "normal",
                    }),
                    valueContainer: (baseStyles) => ({
                      ...baseStyles,
                      paddingLeft: "14px",
                      fontWeight: "normal",
                    }),
                    menu: (baseStyles) => ({
                      ...baseStyles,
                      borderRadius: "5px",
                      marginTop: "4px",
                    }),
                    option: (baseStyles, state) => ({
                      ...baseStyles,
                      fontSize: "15px",
                      backgroundColor: state.isSelected ? "#dbbe78" : state.isFocused ? "#eddfbb" : "#ffffff",
                      color: state.isSelected ? "#ffffff" : "#282828",
                      cursor: "pointer",
                    }),
                    singleValue: (baseStyles) => ({
                      ...baseStyles,
                      fontWeight: "normal",
                    }),
                  }}
                  autoComplete="off"
                  onChange={(option) => setPassengerTitle(option?.value || "")}
                  value={formatPassengerTitle(passengerTitle)}
                  options={passengerTitleOptions}
                  components={{
                    DropdownIndicator: (props) => (
                      <components.DropdownIndicator {...props}>
                        <div className="tw:pr-2">
                          <GoTriangleDown color="#DBBE78" size={16} />
                        </div>
                      </components.DropdownIndicator>
                    ),
                    IndicatorSeparator: () => null,
                  }}
                />
              </div>
              <div className="tw:w-full">
                <input
                  type="text"
                  placeholder={t("editBooking.BookingEditPage.passengerInformation.passengerNamePlaceholder")}
                  value={passengerName}
                  onChange={(e) => setPassengerName(e.target.value)}
                  className={`tw:w-full tw:h-[50px] tw:rounded-[5px] tw:border ${isNameInvalid ? "tw:border-[#C01F12]" : "tw:border-[#e8e8e8]"} tw:bg-white tw:px-[14px] tw:outline-none tw:focus:border-[#282828] ${getTypographyClass(14)} tw:font-hanken-grotesk`}
                />
                {isNameInvalid && (
                  <p className={`tw:!text-[#C01F12] tw:!text-[12px] tw:!mb-0`}>{t("editBooking.BookingEditPage.passengerInformation.passengerNameInvalidMessage")}</p>
                )}
              </div>
            </div>
          </div>

          <div className="tw:flex tw:flex-col tw:gap-2.5">
            <div className={`tw:text-[#212529] ${getTypographyClass(14)}`}>
              {t("editBooking.BookingEditPage.passengerInformation.passengerPhoneNumber")}
            </div>
            <div className={`tw:flex tw:gap-4 tw:items-center tw:h-[50px] tw:border tw:rounded-[5px] tw:pr-[14px] tw:bg-white ${isPhoneInvalid ? "tw:border-[#C01F12]" : "tw:border-[#e8e8e8]"}`}>  
              <div className="tw:min-w-[130px] tw:lg:w-[130px]">
                <Select
                  placeholder={t("SelectCountry.Placeholder")}
                  classNamePrefix="react-select-phone-country"
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      height: "50px",
                      borderRadius: "5px",
                      border: `1px solid ${isPhoneInvalid ? "#C01F12" : "#dbbe78"}`,
                      backgroundColor: "#f9edd3",
                      fontSize: "15px",
                      boxShadow: "none",
                      "&:hover": {
                        border: `1px solid ${isPhoneInvalid ? "#C01F12" : "#dbbe78"}`,
                      },
                      fontWeight: "normal",
                    }),
                    valueContainer: (baseStyles) => ({
                      ...baseStyles,
                      paddingLeft: "12px",
                      fontWeight: "normal",
                    }),
                    menu: (baseStyles) => ({
                      ...baseStyles,
                      borderRadius: "5px",
                      marginTop: "4px",
                    }),
                    option: (baseStyles, state) => ({
                      ...baseStyles,
                      fontSize: "15px",
                      backgroundColor: state.isSelected ? "#dbbe78" : state.isFocused ? "#eddfbb" : "#ffffff",
                      color: state.isSelected ? "#ffffff" : "#282828",
                      cursor: "pointer",
                    }),
                    singleValue: (baseStyles) => ({
                      ...baseStyles,
                      fontWeight: "normal",
                    }),
                  }}
                  autoComplete="off"
                  isSearchable
                  onChange={(option) => {
                    setCountryCode(option?.value || "JP");
                    setPrefixPhoneNumber(option?.dialCode || "+81");
                  }}
                  value={formatPhoneCountry(countryCode)}
                  options={phoneCountryOptions}
                  formatOptionLabel={(option, { context }) => {
                    if (context === "value") {
                      return (
                        <div className="tw:flex tw:items-center tw:gap-2">
                          <CountryFlag
                            code={option.value}
                            emoji={option.flag}
                            alt={option.label}
                            className="tw:w-[21px] tw:h-[15px]"
                          />
                          <span>({option.dialCode})</span>
                        </div>
                      );
                    }

                    return (
                      <div className="tw:flex tw:items-center tw:gap-2">
                        <CountryFlag
                          code={option.value}
                          emoji={option.flag}
                          alt={option.label}
                          className="tw:w-6 tw:h-4"
                        />
                        <span>{`(${option.dialCode}) ${option.label}`}</span>
                      </div>
                    );
                  }}
                  components={{
                    DropdownIndicator: (props) => (
                      <components.DropdownIndicator {...props}>
                        <div className="tw:pr-2">
                          <GoTriangleDown color="#DBBE78" size={16} />
                        </div>
                      </components.DropdownIndicator>
                    ),
                    IndicatorSeparator: () => null,
                  }}
                />
              </div>
              <input
                type="tel"
                placeholder={t("editBooking.BookingEditPage.passengerInformation.passengerPhoneNumberPlaceholder")}
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value.replace(/[^0-9]/g, ""))}
                className={`tw:flex-1 tw:outline-none tw:bg-transparent ${getTypographyClass(14)} tw:font-hanken-grotesk`}
              />
            </div>
            {isPhoneInvalid && (
              <p className={`tw:!text-[#C01F12] tw:!text-[12px]`}>{t("editBooking.BookingEditPage.passengerInformation.passengerPhoneNumberInvalidMessage")}</p>
            )}
          </div>

          {/* {bookingFor === "someone_else" && (
            <label className="tw:!flex tw:items-center tw:gap-x-[10px] tw:cursor-pointer tw:select-none">
              <input
                type="checkbox"
                checked={savePassengerInfo}
                onChange={(e) => setSavePassengerInfo(e.target.checked)}
                className="tw:appearance-none tw:w-5 tw:h-5 tw:border-2 tw:border-[#DBBE78] tw:rounded-[4px] tw:cursor-pointer tw:relative tw:checked:bg-[#DBBE78] tw:checked:after:content-[''] tw:checked:after:absolute tw:checked:after:w-[5px] tw:checked:after:h-[10px] tw:checked:after:border-r-2 tw:checked:after:border-b-2 tw:checked:after:border-white tw:checked:after:rotate-45 tw:checked:after:left-[6px] tw:checked:after:top-[2px]"
              />
              <span className={`tw:text-[#212529] ${getTypographyClass(14)}`}>
                Save this passenger&apos;s info
              </span>
            </label>
          )} */}
        </div>
      </div>
    </section>
  );
});

export default PassengerInformationSection;
